import React, 
       { useEffect, 
         useState, 
         useContext }               from 'react';
import { Card, 
         Container, 
         Row, 
         Col  }                     from 'react-bootstrap';
import { useLocation }              from 'react-router-dom';
import { AuthContext }              from './AuthContext';
import api                          from './AxiosConfig'; 
import ReviewGoalDQT                from './ReviewGoalDQT';
import ReviewGoalDC                 from './ReviewGoalDC';
import ReviewGoalDXY                from './ReviewGoalDXY';
import { useNavigate }              from 'react-router-dom';
import { BsArrowLeftSquareFill }    from 'react-icons/bs';

function ReviewGoal() {
  const [goal, setGoal]               = useState();
  const [goalLoaded, setGoalLoaded]   = useState(false);
  const { state }                     = useLocation();
  const goalId                        = state?.id;
  const { isLoggedIn }                = useContext(AuthContext);
  const navigate        = useNavigate();
       
  useEffect( () => {
    const getGoal = async () => {
        if ( isLoggedIn && isLoggedIn === true && goalId && !goalLoaded ) {
            // Fetch the goal from the backend using axios
            try {
                const fetchedGoal = await api.get(`/site/goals/${encodeURIComponent(goalId)}`, {withCredentials: true });
                setGoal( fetchedGoal.data );
                setGoalLoaded( true );
            } catch (error) {
                console.log("ReviewGoal: " + error);
            }
        }
    }
    getGoal();
  }, [goalId] ); 
       
  const handleBack = () => {
        navigate('/status');     
  };

  return (
    <Container>
    <Row>
    <Col xs={12} sm={6} md={6} lg={6}>
    <Card>
      { goalId && goal && goal.id ? (
        <>
          <Card.Header className="card-goal-header"> 
            <div class="content-container">
              <div class="left-content d-flex align-items-center">
              Goal Review
              </div>
              <div class="right-content">
                <BsArrowLeftSquareFill onClick={() => handleBack()}/>
              </div>
            </div>
            <Card.Subtitle className="text-center">{goal.goal_title}</Card.Subtitle>
            <Card.Subtitle className="text-center">{goal.goal_description}</Card.Subtitle>
          </Card.Header>
         <Card.Body>
           { goal.goal_type === 3 && ( <ReviewGoalDQT goal={goal} /> ) } 
           { goal.goal_type === 2 && ( <ReviewGoalDC  goal={goal} /> ) } 
           { goal.goal_type === 4 && ( <ReviewGoalDXY goal={goal} /> ) } 
           { goal.goal_type === 5 && ( <ReviewGoalDXY goal={goal} /> ) } 
         </Card.Body>
         </>
      ) : (
        <p>No Element ID received.</p>
      )}
    </Card>
    </Col>
    </Row>
    </Container>
  );
}

export default ReviewGoal;
